module.exports = __webpack_public_path__ + "img/vimlogo.f38542de.png";